<app-breadcrumb></app-breadcrumb>

<h2 class="ms-4 roboto-medium mb-2">AET Reports</h2>

<header>
    <div class="container ms-4 ps-0 roboto-medium ">
        <div class="row">
            <div class="icon" (click)="openMenu()">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="menu" [class.menuClass]="menuVariable">
            <ul class="d-flex">
               <li class="bar" routerLink="/reports-dashboard" routerLinkActive="active-link">AET Dashboard</li>
               <div class="vr"></div><li class="bar" routerLink="/reports-history" routerLinkActive="active-link">AET History</li>
               <div class="vr"></div><li class="bar" routerLink="/reports-import" routerLinkActive="active-link">AET Import Template Populated</li>
               <div class="vr"></div><li class="bar" routerLink="/reports-order-info" routerLinkActive="active-link">AET Order Information</li>
               <div class="vr"></div><li class="bar" routerLink="/reports-safety-dashboard" routerLinkActive="active-link">AET Safety Dashboard </li>
               <div class="vr"></div><li class="bar" routerLink="/reports-border-crossing" routerLinkActive="active-link">Cross Border Routes</li>
            </ul>
            </div>
        </div>
    </div>
</header>

<hr class="ms-4">
<br>
